import React, { useEffect, useState } from "react";

// Components
import { COLOR_APP, COLOR_TEXT, S3_URL } from "../../constants";
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  UPDATE_CATEGORY,
} from "../../graphql/category/mutation";
import { GET_CATEGORYS } from "../../graphql/category/query";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useQueryCategoryData } from "../../services/categoryService/queries";

// Libraries
import {
  Button,
  Table,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment";

// Icons
import { BiCategory } from "react-icons/bi";
import { IoMdAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import _ from "lodash";


export default function CategoryLists({ shopId }) {
  const [isAddModal, setIsAddModal] = useState(false);
  const [isDelModal, setIsDelModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [search, setSearch] = useState()
  const [categoryName, setCategoryName] = useState();
  const [descriptions, setDescription] = useState();
  const [categoryDatas, setCategoryDatas] = useState([]);
  const [categoryTotal, setCategoryTotal] = useState(0);
  const [prepareId, setPrepareId] = useState();

  const { queryCategoryDatas, loadCategoryData, loadingCategoryDatas, error } = useQueryCategoryData();

  // GraphQL Clients
  const [createCategory, { loading: loadingCGR }] =
    useMutation(CREATE_CATEGORY);
  const [updateCategory, { loading: loadingUGR }] =
    useMutation(UPDATE_CATEGORY);
  const [deletedCategory, { loading: loadingDelete }] =
    useMutation(DELETE_CATEGORY);

  // useEffect Hooks
  useEffect(() => {
    fetchCategoryData();
  }, [search]);

  useEffect(() => {
    if (loadCategoryData) {
      setCategoryDatas(loadCategoryData?.categories?.data);
      setCategoryTotal(loadCategoryData?.categories?.total);
    }
  }, [loadCategoryData]);

  // Handle fetch data
  const fetchCategoryData = async () => {
    await queryCategoryDatas({ _name: search });
  };


  const onCloseModal = () => {
    setCategoryName("");
    setDescription("");
    setIsAddModal(false);
    setValidated(false);
    setIsDelModal(false);
    setEditMode(false)
  };

  // create category data
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const form = e.currentTarget;
      if (loadingCGR) return;

      if (form.checkValidity() === true) {
        e.stopPropagation();
        const response = await createCategory({
          variables: {
            data: {
              name: categoryName,
              note: descriptions,
              shop: shopId,
            },
          },
        });

        if (response?.data?.createCategory?.message === "CREATED_SUCCESS") {
          fetchCategoryData();
          onCloseModal();
        }
        return;
      }


      setValidated(true);
    } catch (error) {
      setValidated(false);
      console.error("Error creating category:", error);
    }
  };

  // udpate category
  const onUpdateCategory = async (e) => {
    e.preventDefault();
    try {
      if (loadingUGR) return;
      await updateCategory({
        variables: {
          where: {
            id: prepareId,
          },
          data: {
            name: categoryName,
            note: descriptions,
          },
        },
      }).then(() => {
        onCloseModal();
        fetchCategoryData();
      });
    } catch (error) {
      console.error(error);
    }
  };

  // confirm delete category data
  const onDeleteCategory = async () => {
    try {
      if (loadingDelete) return;
      const res = await deletedCategory({
        variables: {
          where: {
            id: prepareId,
          },
        },
      });

      if (res?.data?.deleteCategory?.message === "DELETED_SUCCESS") {
        onCloseModal();
        fetchCategoryData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // edit category
  const handleEdit = (data) => {
    setEditMode(true);
    setIsAddModal(true);
    setCategoryName(data?.name);
    setDescription(data?.note);
    setPrepareId(data?.id);
  };

  // prepare confirm modal deleted
  const handleDelete = (id) => {
    setIsDelModal(true)
    setPrepareId(id);
  }


  return (
    <>
      <div className="d-flex flex-column p-4 w-100">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <BiCategory style={{ fontSize: 27 }} />
          <h5>ລາຍການປະເພດສິນຄ້າ [{categoryTotal ?? 0}]</h5>
        </div>
        <br />
        <div className="d-flex w-100 gap-4 justify-content-between align-items-center">
          <Form.Group className="mb-3 w-100" controlId="categories">
            <Form.Label>ຄົ້ນຫາ</Form.Label>
            <Form.Control value={search} onChange={(e) => setSearch(e?.target?.value)} type="text" placeholder="ປ້ອນຊື່ປະເພດ..." />
          </Form.Group>
          <Button
            style={{
              background: COLOR_APP,
              marginTop: 15,
              color: "#fff",
              minWidth: 200,
            }}
            onClick={() => setIsAddModal(true)}
          >
            <IoMdAdd />
            ເພິ່ມ
          </Button>
        </div>
        <div className="py-2">
          {loadingCategoryDatas && !loadCategoryData ? (
            <LoadingSpinner />
          ) : (
            <Table striped bordered>
              <thead>
                <tr>
                  <th style={{ border: "none" }}>ລຳດັບ</th>
                  <th style={{ border: "none" }}>ປະເພດສິນຄ້າ</th>
                  <th style={{ border: "none" }}>ວັນທີ,ເດືອນ,ປີ</th>
                  <th style={{ border: "none" }}>ລາຍລະອຽດ</th>
                  <th style={{ border: "none", textAlign: "right" }}>ຈັດການ</th>
                </tr>
              </thead>
              <tbody>
                {categoryDatas.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.name ?? "-"}</td>
                    <td>{moment(item?.createdAt).format("DD/MM/YYYY")}</td>
                    <td>{item?.note ?? "-"}</td>
                    <td style={{ width: 200, textAlign: "right" }}>
                      <Button
                        variant="outline-secondary"
                        onClick={() => handleEdit(item)}
                      >
                        <FaEdit />
                        ແກ້ໄຂ
                      </Button>
                      &nbsp;
                      <Button variant="outline-danger"

                        onClick={() => handleDelete(item?.id)}
                      >
                        <MdDelete />
                        ລົບ
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <Modal centered show={isAddModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode ? "ແກ້ໄຂປະເພດສິນຄ້າ" : "ເພິ່ມປະເພດສິນຄ້າ"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={editMode ? onUpdateCategory : handleSubmit}
          >
            <Row className="mb-3 w-100">
              <Form.Group controlId="categoryName" className="w-100">
                <Form.Label>ຊື່ປະເພດສິນຄ້າ</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="ປ້ອນປະເພດສິນຄ້າ"
                  className="w-100"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e?.target?.value)}
                />
                <Form.Control.Feedback type="invalid">
                  ກາລຸນາປ້ອນຂໍ້ມູນກ່ອນ!
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="categoryDescription" className="w-100">
                <Form.Label>ລາຍລະອຽດ</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ປ້ອນລາຍລະອຽດ"
                  className="w-100"
                  as="textarea"
                  rows={3}
                  value={descriptions}
                  onChange={(e) => setDescription(e?.target?.value)}
                />
              </Form.Group>
            </Row>
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                type="button"
                onClick={onCloseModal}
              >
                ຍົກເລິກ
              </Button>
              {editMode ? (
                <Button
                  type="submit"
                  style={{ background: COLOR_APP, color: "#fff" }}
                >
                  {loadingUGR && <Spinner />} ແກ້ໄຂ
                </Button>
              ) : (
                <Button
                  type="submit"
                  style={{ background: COLOR_APP, color: "#fff" }}
                >
                  {loadingCGR && <Spinner />} ບັນທຶກ
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* confirm deleted category */}
      <ModalConfirmComponent
        showConfirmModal={isDelModal}
        handleCancel={() => setIsDelModal(false)}
        handleConfirm={onDeleteCategory}
        loadingConfirm={loadingDelete}
        title="ແຈ້ງເຕືອນ"
        text={"ທ່ານຕ້ອງການລົບປະເພດນີ້ແທ້ບໍ່?"}
      />
    </>
  );
}
